<template>
	
	<el-container class="container" ref="homePage">
	  <el-header class="header" style="height: 70px;">
	    <div class="logo_container">
	      <a href="http://www.jinshisoft.com/" target="_blank"><img :src="logo" class="logo" /></a>
	    </div>
	    <div class="top_menu">
	      {{AppName}}
	    </div>
			<div class="tianqi">
				<!-- <iframe width="100%" frameborder="0" scrolling="no" hspace="0" src="https://i.tianqi.com/?c=code&a=getcode&id=35&h=55&w=200"></iframe> -->
			  <iframe width="210" scrolling="no" height="60" frameborder="0" allowtransparency="true" src="https://i.tianqi.com?c=code&id=12&color=%23333333&icon=1&num=1&site=12"></iframe>
			</div>
	  </el-header>
	  <el-container class="main">
	    
	    <el-main class="content-container" ref="main">
				<div class="search">
					<el-input placeholder="请输入要搜索的内容" v-model="keyword" class="input-with-select" @keyup.enter.native="Search" >
						<el-select v-model="leixing" slot="prepend" placeholder="请选择" style="width: 100px;">
							<el-option label="全部" value="全部"></el-option>
							<el-option label="带视频" value="带视频"></el-option>
						</el-select>
						<el-button slot="append" icon="el-icon-search" @click="Search"></el-button>
					</el-input>
				</div>
	      <div class="container2">
					<el-tree :data="muluList" node-key="ID" :current-node-key="currentKey" :highlight-current="true"
					  :filter-node-method="filterNode" :accordion="false" :default-expand-all="false"
					  :expand-on-click-node="true" ref="tree" style="width: 100%;" @node-click="getNode"
					  :empty-text="emptyText" :default-expanded-keys="expandedKeys">
					  <span class="custom-tree-node" slot-scope="{ node, data }">
					    <span v-if="data.type=='0'" class="mulu">
					      <span>
					        <img src="/static/images/folder-open.png" class="node-icon" v-if="node.expanded==true" />
					        <img src="/static/images/folder.png" class="node-icon" v-else />
					        {{ data.目录名称 }}
					      </span>
								
					    </span>
					    <span v-if="data.type == '1'" class="subject">
					      <a :href="'view/' + data.ID">
									<i class="el-icon-s-order node-icon-2" style="margin-right: 0px;" alt="1"></i>
					      {{ data.标题 }}
								<!-- <span v-if="data.带视频=='1'" class="ri-live-line" style="font-size: 18px; vertical-align: bottom;"></span> -->
								<span v-if="data.带视频=='1'"><img src="../assets/camera.png" height="14"></span>
					      </a>
					    </span>
							<span>&nbsp;<span class="line"></span></span>
							<span class="date">{{data.创建时间}}</span>
					  </span>
					</el-tree>
				</div>
	    </el-main>
	  </el-container>
	</el-container>
</template>

<script>
	import * as util from '@/utils/util.js';
	import { mapState } from 'vuex';
	
	
	export default {
	  data() {
	    return {
	      redirect: '',
				data:[],
				muluList: [],
				currentKey: '',
				emptyText: '',
				expandedKeys: ['0'],
				AppName: '帮助文档',
				logo: require('../assets/czylogo.png'),
				keyword: '',
				leixing: '全部',
				AppID: '1AAFCAB4-60B8-48A7-B14D-84E0276C6F47',
	    }
	  },
	  created() {
	    let that = this;
	    //console.log('lang:' + localStorage.lang)
	
	    let userinfo=util.GetUserInfo();  //获取当前登录用户信息
	
	    //console.log(`当前用户：${userinfo.logname}`);
			this.GetHelpWenDangList(this.AppID);
	  },
	  mounted(){
	  	
	    this.$nextTick(() => {
				/*
				// 禁用鼠标右键菜单
				document.addEventListener('contextmenu', function(e) {
						e.preventDefault();
						return false;
				});
				
				// 禁用键盘按键（F12 及常见开发者工具快捷键）
				document.addEventListener('keydown', function(e) {
					
					// 禁用 F12
					if (e.key === 'F12' || e.keyCode === 123) {
							e.preventDefault();
							return false;
					}
					
					// 禁用 Ctrl+Shift+I (开发者工具)
					if (e.ctrlKey && e.shiftKey && (e.key === 'I' || e.key === 'i')) {
							e.preventDefault();
							return false;
					}
					
					// 禁用 Ctrl+Shift+J (控制台)
					if (e.ctrlKey && e.shiftKey && (e.key === 'J' || e.key === 'j')) {
							e.preventDefault();
							return false;
					}
					
					// 禁用 Ctrl+Shift+C (元素选择器)
					if (e.ctrlKey && e.shiftKey && (e.key === 'C' || e.key === 'c')) {
							e.preventDefault();
							return false;
					}
					
					// 禁用 Ctrl+U (查看源代码)
					if (e.ctrlKey && (e.key === 'U' || e.key === 'u')) {
							e.preventDefault();
							return false;
					}
					
				});
				//屏蔽复制
				document.oncopy = function (event) {
					if (window.event) {
						event = window.event;
					} 
					try {
						var the = event.srcElement;
						if (!((the.tagName == "INPUT" && the.type.toLowerCase() == "text") || the.tagName == "TEXTAREA"))
						{
							return false;
						}
						return true;
					} catch (e) {
						return false;
					}
				}
				//屏蔽选中
				document.onselectstart = function (event) {
					if (window.event) {
						event = window.event;
					}
					try {
							var the = event.srcElement;
							if (!((the.tagName == "INPUT" && the.type.toLowerCase() == "text") || the.tagName == "TEXTAREA")) {
								return false;
							}
							return true;
					}
					catch (e) {
						return false;
					}
				}
				*/
	    });
	  
	  },
	  methods: {
			filterNode(value, data) {
			  if (!value) return true;
			  return data.label.indexOf(value) !== -1;
			},
			GetHelpWenDangList(UUID){
				let url="/Handler/Help.ashx?mode=GetHelpWenDangList";
				this.$ajax.post(url,{UUID: UUID}).then((response)=>{
				  //console.log(response.data);
				  //console.log(JSON.stringify(response.data));
				  let errorCode=response.data.errorCode;
				  if(errorCode=='0')
				  {
				    	for(let item of response.data.data){
								this.expandedKeys.push(item.ID);
							}
				    //this.data = [{label: '根目录', 目录名称: '根目录', ID: '0', AutoID: '0',disabled: true, children: response.data.data}];
				    this.data = response.data.data;
				    
				    this.muluList=JSON.parse(JSON.stringify(this.data));
						
						//console.log(this.muluList);
				  }
				  
				});
				
			},
			getNode(node){
				return;
				if(node.标题){
					this.$router.push({path: 'view/' + node.ID});
				}
			},
			Search(){
				//console.log('this.keyword', this.keyword);
				
				if(this.keyword || this.leixing=='带视频'){
					//this.$router.push({path: 'search/' + this.AppID + '/' + encodeURIComponent(this.keyword)});
					
					window.open('/search/' + this.AppID + '/' + encodeURIComponent(this.leixing) + '/' + encodeURIComponent(this.keyword), 'search');
				}
			}
	  }
	}
</script>

<style lang="scss" scoped="scoped">
	.container {
		position: absolute;
		top: 0px;
		bottom: 0px;
		width: 100%;
		height: 100%;
		border: 0px solid #F00;
		overflow-y: auto;
		.header {
			padding: 0;
			height: 70px;
			line-height: 70px;
			// background-color: #3389e0;
			background-color: #43b6c8;
			background-color: #ffffff;
			border-bottom: 1px solid #377a84;
			border-bottom: 3px solid #eeeeee;
			color: #666666;
			font-size: 25px;
			text-align: left;
			.logo_container {
				float: left;
				border: 0px solid #FF0000;
				width: 150px;
				// background-color: #1271d0;
				// background-color: #377a84;
				text-align: center;
				.logo {
					margin: 0 auto;
					width: 100px;
					border: 0px solid #FF0000;
					vertical-align: middle;
	
				}
				
			}
			.title{
				font-family: 微软雅黑;
				float: left;
				font-size: 24px;
				padding-left: 20px;
				border: 0px solid #F00;
				letter-spacing: 5px;
			}
			.top_menu {
			  float: left;
			  border: 0px solid #FF6600;
				padding-left: 20px;
			  height: 70px;
			  
			}
			.tianqi{
				float: right;
			  margin-top: 5px;
			  width: 210px;
			  height: 60px;
			  overflow: hidden;
			}
		}
		.main {
			padding-left: 0;
			// display: flex;
			position: relative;
			// top: 0px;
			// bottom: 0px;
			width: 100%;
			.menu-container {
				//padding: 10px;
				// flex: 0 0 200px;
				width: 120px;
				//background-color: #333c4b;
				background-color: #344772;
				background-color: #424256;
				background-color: #f1f4f8;
				text-align: left;
				overflow-x: hidden;
				overflow-y: auto;
				border-right: 1px solid #DDDDDD;
				
			}
			.menu-collapsed{
				flex:0 0 50px;
				width: 50px;
			}
			.menu-expanded{
				flex:0 0 350px;
				width: 350px;
				padding-top: 0px;
			}
			.content-container {
				padding: 0;
				padding-top: 0px;
				flex: 1;
				height: 100%;
				overflow-y: auto;
				background-color: #F7F8F9;
				background-color: #FFFFFF;
				position: relative;
				text-align: left;
				.container2{
					margin: 0 auto;
					padding: 10px;
					width: 1000px;
					text-align: left;
				}
			}
		}
	}
.title{
	line-height: 50px;
	font-size: 20px;
}
.main {
	margin: 0 auto;
	width: 1000px;
	padding: 30px 0px;
	font-size: 25px;
  border: 0px solid #F0C78A;
}
.search{
	margin: 10px auto;
	width: 700px;
}
.custom-tree-node {
	flex: 1;
	display: flex;
	align-items: center;
	justify-content: space-between;
	font-size: 16px;
	padding-right: 8px;
	position: relative;
}
.line{
	text-align: right;
	z-index: 2;
	&::before{
		content: ' ';
		width: 78%;
		border-bottom: 1px dashed #cccccc;
		position: absolute;
		top: 50%;
		right: 130px;
	}
}
.mulu{
	color: #000000;
	font-weight: bold;
	img{
		border: 0 solid #FFFFFF;
	}
}
.subject{
	color: #333333;
	z-index: 3;
	a{
		color: #333333;
		&:active{
			color: #3399ff;
		}
	}
}
.date{
	color: #aaaaaa;
	font-size: 14px;
}
/deep/ .el-tree--highlight-current .el-tree-node.is-current > .el-tree-node__content {
  background-color: #3399ff;
  background-color: #cbd6e4;
  color: #414e5f;
  // color: #ffffff;
}
/deep/ .el-tree-node__expand-icon{
	color: #000000;
	font-size: 16px;
}
/deep/ .el-tree-node__expand-icon.is-leaf{
	color: transparent;
}
/deep/ .el-icon-search:before{
	font-size: 22px;
}
a {
	text-decoration: none;
}
</style>